// ==========================================
// 1. MODAL OPEN / CLOSE LOGIC
// ==========================================
(function() {
  function openModal() {
    const modal = document.getElementById('pc-modal-wrapper');
    if (!modal) return;
    
    // ADD THE CSS CLASS TO LOCK SCROLLING PERFECTLY ON ALL DEVICES
    document.body.classList.add('bm-modal-open');
    
    modal.style.visibility = 'visible'; 
    modal.style.opacity = '';
    modal.style.pointerEvents = '';
    modal.classList.remove('pc-hidden');
  }

  function closeModal() {
    const modal = document.getElementById('pc-modal-wrapper'); 
    if (!modal) return;
    modal.classList.add('pc-hidden');
    
    setTimeout(() => {
      modal.style.visibility = 'hidden';
      modal.style.pointerEvents = 'none';
    }, 250);

    // REMOVE THE CSS CLASS TO UNLOCK SCROLLING
    document.body.classList.remove('bm-modal-open');
  }

  window.pcOpenModal = openModal;
  window.pcCloseModal = closeModal;

  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-pc-open]')) {
      e.preventDefault(); 
      openModal();
    }
    if (e.target.closest('[data-pc-close]') || e.target.classList.contains('pc-modal__backdrop')) {
      closeModal();
    }
  });
})();


// ==========================================
// 2. MAIN CUSTOMISER LOGIC
// ==========================================
(function () {
  function initCustomiser(root) {
    const state = {
      step: 1,
      artworkMode: 'each', 
      positions: [] 
    };

    // DOM Elements
    const stepTabs = root.querySelectorAll('[data-pc-step-tab]');
    const steps = root.querySelectorAll('[data-pc-step]');
    const btnNextArtwork = root.querySelector('#btn-next-artwork');
    const btnNextConfirm = root.querySelector('#btn-next-confirm');
    const btnCheckout = root.querySelector('#btn-checkout-final');
    const btnBacks = root.querySelectorAll('[data-pc-back-to]');
    
    const artworkContainer = root.querySelector('#pc-dynamic-artwork-container');
    const summaryContainer = root.querySelector('#pc-dynamic-summary-container');

    // SVGs for dynamic rendering
    const iconUpload = `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M5,20.99994c-.55,0-1.02083-.19583-1.4125-.5875-.39167-.39167-.5875-.8625-.5875-1.4125V4.99994c0-.55.19583-1.02083.5875-1.4125.39167-.39167.8625-.5875,1.4125-.5875h8v2H5v14h14v-8h2v8c0,.55-.19583,1.02083-.5875,1.4125-.39167.39167-.8625.5875-1.4125.5875H5ZM6,16.99994h12l-3.75-5-3,4-2.25-3-3,4ZM17,8.99994v-2h-2v-2h2v-2h2v2h2v2h-2v2h-2Z"/></svg>`;
    const iconUploadlogo = `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M10.76274,5.6216v11.92483h2.77322V5.6216l5.54643,5.54643,1.94125-1.94125L13.11998,1.32312c-.55464-.55464-1.38661-.55464-1.94125,0l-7.90367,7.90367,1.94125,1.94125,5.54643-5.54643Z"/><path fill="currentColor" d="M20.46908,20.31965H3.82978v-4.15982H1.05656v5.54643c0,.83196.55464,1.38661,1.38661,1.38661h19.41252c.83196,0,1.38661-.55464,1.38661-1.38661v-5.54643h-2.77322v4.15982Z"/></svg>`;
    const iconEmail = `<svg viewBox="4 16 92 92"><path fill="currentColor" d="M50,21.5c-22.6081,0-41,18.39197-41,41.00006s18.3919,41,41,41,41-18.39209,41-41.00006-18.3919-41.00006-41-41.00006v.00006ZM50,27.5c19.3654,0,35,15.63464,35,35.00006s-15.6346,35-35,35S15,81.86542,15,62.5,30.6346,27.49994,50,27.49994v.00006ZM47,35.49994v25.28119s-20.1562,11.62506-20.1562,11.62506c-1.43501.82843-1.9222,2.659-1.0938,4.09381.82841,1.43488,2.659,1.92212,4.0938,1.09369l21.6562-12.5c.8954-.51898,1.5-1.48431,1.5-2.59369v-27.00006c0-1.6568-1.3432-3-3-3-1.6569,0-3,1.3432-3,3Z"/></svg>`;
    const iconFile = `<svg viewBox="4 12 96 76"><path fill="currentColor" d="M95.3,39.6v-.4q0-.1-.1-.2,0-.1-.1-.2c0-.1-.1-.1-.1-.2s-.1-.1-.1-.2-.1-.1-.1-.1l-.1-.1-.1-.1c-.1,0-.1-.1-.2-.1s-.1-.1-.2-.1-.1-.1-.2-.1h-10.00002c0-.2.1-.3.1-.5,0-6.4-5.2-11.6-11.6-11.6h-29.4v-5.8c0-3.9-3.2-7.1-7.1-7.1H11.8c-3.9,0-7.1,3.2-7.1,7.1v58.3c0,2,.7,3.9,1.8,5.4,0,0,0,.1.1.1,1.7,2.3,4.4,3.7,7.4,3.7h58.6c6.4-.09999,10.1-5.39999,11.4-10.3h0l11.3-36.8v-.7c0,.1,0,0,0,0ZM80,37.2c0,.2,0,.3.1.5H21q-.1,0-.2.1-.1,0-.2.1c-.1,0-.1.1-.2.1s-.1.1-.1.1c-.1,0-.1.1-.2.1l-.1.1c0,.1-.1.1-.1.2,0,0-.1.1-.1.2s-.1.1-.1.2-.1.1-.1.2v.1l-11,34.59999V29.6h63.8c4.2,0,7.60001,3.4,7.60001,7.6ZM11.8,16.7h24.2c1.7,0,3.1,1.4,3.1,3.1v5.8H8.7v-5.8c0-1.7,1.3-3.1,3.1-3.1ZM72.4,83.3H13.9c-1.4,0-2.7-.6-3.6-1.5l12.7-40.1h67.7l-10.6,34.2v.1h0c-.4,1.7-2.3,7.3-7.7,7.3Z"/></svg>`;
    const iconTick = `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/></svg>`;

    // --- NAVIGATION LOGIC ---
    function goToStep(targetStep) {
      if (targetStep === 2 && state.positions.length === 0) {
        alert('Please select at least one position to continue.');
        return;
      }
      
      state.step = targetStep;
      steps.forEach(stepEl => {
        const n = Number(stepEl.getAttribute('data-pc-step'));
        stepEl.classList.toggle('pc__step--active', n === targetStep);
      });

      stepTabs.forEach(tab => {
        const n = Number(tab.getAttribute('data-pc-step-tab'));
        tab.classList.remove('pc__step-tab--active', 'pc__step-tab--completed');
        if (n === targetStep) tab.classList.add('pc__step-tab--active');
        if (n < targetStep) tab.classList.add('pc__step-tab--completed');
      });

      if (targetStep === 2) renderArtworkStep();
      if (targetStep === 3) renderSummaryStep();
      
      // ADD THIS RIGHT HERE AT THE END OF goToStep:
      if (window.innerWidth <= 768) {
            setTimeout(() => {
              // Target the wrapper instead of the dialog!
              const wrapper = document.querySelector('.pc-modal-wrapper');
              if (wrapper) wrapper.scrollTop = 0;
            }, 50);
          }
    }

    if(btnNextArtwork) btnNextArtwork.addEventListener('click', () => goToStep(2));
    if(btnNextConfirm) {
      btnNextConfirm.addEventListener('click', () => {
        let isValid = true;
        state.positions.forEach(p => {
          if (!p.isSaved) isValid = false;
        });
        if (!isValid) {
          alert("Please ensure you 'Save Configuration' for each logo position before continuing.");
          return;
        }
        goToStep(3);
      });
    }
    btnBacks.forEach(btn => btn.addEventListener('click', (e) => goToStep(Number(e.target.getAttribute('data-pc-back-to')))));


    // --- STEP 1: APPLICATION LOGIC ---
    function syncPositionsState() {
      const cards = root.querySelectorAll('[data-position-card]');
      let newPositions = [];

      cards.forEach(card => {
        const checkbox = card.querySelector('.pc-pos-checkbox');
        if(!checkbox) return;

        const activeRadio = card.querySelector('input[type="radio"]:checked');
        const priceDisplay = card.querySelector('[data-dynamic-price]');
        const typeToggle = card.querySelector('.pc__pos-type-toggle');
        const checkIcon = card.querySelector('.pc__pos-check');

        if (typeToggle) {
          typeToggle.style.display = checkbox.checked ? 'flex' : 'none';
          if (checkbox.checked) {
            typeToggle.style.justifyContent = 'center';
            typeToggle.style.gap = '15px';
            typeToggle.style.marginTop = '10px';
          }
        }
        if (checkIcon) {
          checkIcon.style.display = checkbox.checked ? 'flex' : 'none';
        }

        if (checkbox.checked) {
          card.classList.add('is-selected');
          card.style.borderColor = '#3ec0b8'; 
        } else {
          card.classList.remove('is-selected');
          card.style.borderColor = '#e5e5e5'; 
        }

        if (activeRadio && priceDisplay) {
           priceDisplay.innerText = `| £${Number(activeRadio.getAttribute('data-price')).toFixed(2)}`;
        }

        if (checkbox.checked && activeRadio) {
          const positionLabel = checkbox.value;
          const existing = state.positions.find(p => p.label === positionLabel);
          
          newPositions.push({
            label: positionLabel,
            imgSrc: card.querySelector('img')?.src || '',
            type: activeRadio.value,
            price: Number(activeRadio.getAttribute('data-price')),
            variantId: activeRadio.getAttribute('data-variant-id'),
            artworkMethod: existing ? existing.artworkMethod : 'upload',
            logoName: existing ? existing.logoName : '',
            fileObj: existing ? existing.fileObj : null,
            fileName: existing ? existing.fileName : '',
            isSaved: existing ? existing.isSaved : false
          });
        }
      });
      state.positions = newPositions;
    }

    root.querySelectorAll('[data-position-card]').forEach(card => {
      const checkbox = card.querySelector('.pc-pos-checkbox');
      const radios = card.querySelectorAll('input[type="radio"]');

      if(checkbox) checkbox.checked = false;
      radios.forEach(r => r.checked = false);

      card.addEventListener('click', (e) => {
        if (e.target.closest('.pc__pos-type-toggle')) return;
        
        if(checkbox) checkbox.checked = !checkbox.checked; 
        handleCardToggle();
      });

      radios.forEach(radio => {
        radio.addEventListener('change', () => {
          if(checkbox) checkbox.checked = true; 
          syncPositionsState();
        });
      });

      function handleCardToggle() {
        if (checkbox && checkbox.checked) {
          const activeRadio = card.querySelector('input[type="radio"]:checked');
          if (!activeRadio && radios.length > 0) {
            const embroideryRadio = Array.from(radios).find(r => r.value.toLowerCase().includes('embroidery')) || radios[0];
            if (embroideryRadio) embroideryRadio.checked = true;
          }
        } else {
          radios.forEach(r => r.checked = false);
        }
        syncPositionsState();
      }
    });

    syncPositionsState();


    // --- STEP 2: ARTWORK LOGIC ---
    const artworkModeRadios = root.querySelectorAll('input[name="artwork_mode"]');
    artworkModeRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        root.querySelectorAll('.pc__art-mode-card').forEach(c => c.classList.remove('pc__card--active'));
        e.target.closest('.pc__art-mode-card').classList.add('pc__card--active');
        state.artworkMode = e.target.value;
        
        if (state.artworkMode === 'same' && state.positions.length > 0) {
           const master = state.positions[0];
           state.positions.forEach(p => {
             p.artworkMethod = master.artworkMethod;
             p.logoName = master.logoName;
             p.fileObj = master.fileObj;
             p.fileName = master.fileName;
             p.isSaved = master.isSaved;
           });
        }
        renderArtworkStep();
      });
    });

    function generateArtworkRowHTML(pos, index, isMaster = false) {
      const modeId = isMaster ? 'master' : index;
      
      if (pos.isSaved) {
        return `
          <div class="pc-art-row">
            ${!isMaster ? `
              <div class="pc-art-header">
                <div class="pc-art-header-img">${pos.imgSrc ? `<img src="${pos.imgSrc}">` : ''}</div>
                <div class="pc-art-header-info"><strong>${pos.label}</strong><span>${pos.type}</span></div>
              </div>
            ` : ''}
            <div class="pc-art-saved">
              <div class="saved-msg">${iconTick} Logo added to this position</div>
              <button type="button" class="pc-btn-update" data-edit-row="${modeId}">Update Selection</button>
            </div>
          </div>
        `;
      }

      const isUpload = pos.artworkMethod === 'upload';
      const isEmail = pos.artworkMethod === 'email';
      const isFile = pos.artworkMethod === 'file';

      return `
        <div class="pc-art-row" data-row-id="${modeId}">
          ${!isMaster ? `
            <div class="pc-art-header">
              <div class="pc-art-header-img">${pos.imgSrc ? `<img src="${pos.imgSrc}">` : ''}</div>
              <div class="pc-art-header-info"><strong>${pos.label}</strong><span>${pos.type}</span></div>
            </div>
          ` : '<p style="font-size:14px; margin-bottom: 20px;">Choose how you’d like to apply your logo(s) to all positions.</p>'}

          <div class="pc-art-methods">
            <label class="pc-art-method ${isUpload ? 'is-active' : ''}">
              <input type="radio" name="method_${modeId}" value="upload" ${isUpload ? 'checked' : ''} data-method-change>
              <div class="method-icon">${iconUpload}</div>
              <span>Upload Logo Now</span>
            </label>
            <label class="pc-art-method ${isEmail ? 'is-active' : ''}">
              <input type="radio" name="method_${modeId}" value="email" ${isEmail ? 'checked' : ''} data-method-change>
              <div class="method-icon">${iconEmail}</div>
              <span>Email Logo Later</span>
            </label>
            <label class="pc-art-method ${isFile ? 'is-active' : ''}">
              <input type="radio" name="method_${modeId}" value="file" ${isFile ? 'checked' : ''} data-method-change>
              <div class="method-icon">${iconFile}</div>
              <span>Use Logo on File</span>
            </label>
          </div>

          <div class="pc-art-inputs">
            ${isUpload ? `<div class="pc-warning-banner">If you have uploaded this logo to us before, select 'Use Logo on File' as it will prevent additional set up costs.</div>` : ''}
            
            <div class="pc-input-group">
              <label>Logo Name <span>*</span></label>
              <div class="pc-input-row">
                <input type="text" placeholder="e.g. Company Logo" value="${pos.logoName}" data-name-input>
                ${isUpload ? `
                  <label class="pc-btn-upload">
                    ${iconUploadlogo} Choose File
                    <input type="file" accept="image/*,application/pdf,.eps,.ai,.psd" style="display:none;" data-file-input>
                  </label>
                  ${pos.fileName ? `<span class="pc-upload-name">Uploaded Logo: <span class="file-name">${pos.fileName}</span></span>` : ''}
                ` : ''}
              </div>
              ${isUpload ? `<div class="pc-input-help">No need to stress about the design; we'll polish it up and send a proof before it goes on your products!<br>Upload your file in JPG, PNG, EPS, AI, PSD or PDF format, max 8MB.</div>` : ''}
            </div>

            <div style="display: flex; justify-content: flex-end; margin-top: 15px;">
               <button type="button" class="pc-btn-update" data-save-row="${modeId}">Save Configuration</button>
            </div>
          </div>
        </div>
      `;
    }

    function renderArtworkStep() {
      if (!artworkContainer) return;
      let html = '';

      if (state.artworkMode === 'same') {
        html = generateArtworkRowHTML(state.positions[0], 0, true);
      } else {
        state.positions.forEach((pos, index) => {
          html += generateArtworkRowHTML(pos, index, false);
        });
      }
      
      artworkContainer.innerHTML = html;
      bindArtworkRowEvents();
    }

    function bindArtworkRowEvents() {
      artworkContainer.querySelectorAll('[data-method-change]').forEach(radio => {
        radio.addEventListener('change', (e) => {
          const rowId = e.target.closest('.pc-art-row').getAttribute('data-row-id');
          const method = e.target.value;
          
          if (rowId === 'master') {
            state.positions.forEach(p => p.artworkMethod = method);
          } else {
            state.positions[Number(rowId)].artworkMethod = method;
          }
          renderArtworkStep();
        });
      });

      artworkContainer.querySelectorAll('[data-name-input]').forEach(input => {
        input.addEventListener('input', (e) => {
          const rowId = e.target.closest('.pc-art-row').getAttribute('data-row-id');
          if (rowId === 'master') {
            state.positions.forEach(p => p.logoName = e.target.value);
          } else {
            state.positions[Number(rowId)].logoName = e.target.value;
          }
        });
      });

      artworkContainer.querySelectorAll('[data-file-input]').forEach(input => {
        input.addEventListener('change', (e) => {
          const rowId = e.target.closest('.pc-art-row').getAttribute('data-row-id');
          const file = e.target.files[0];
          if (file) {
            if (rowId === 'master') {
              state.positions.forEach(p => { p.fileObj = file; p.fileName = file.name; });
            } else {
              state.positions[Number(rowId)].fileObj = file;
              state.positions[Number(rowId)].fileName = file.name;
            }
            renderArtworkStep();
          }
        });
      });

      artworkContainer.querySelectorAll('[data-save-row]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const rowId = e.target.getAttribute('data-save-row');
          const targetPos = rowId === 'master' ? state.positions[0] : state.positions[Number(rowId)];
          if (!targetPos.logoName.trim()) { alert('Please enter a Logo Name.'); return; }
          if (targetPos.artworkMethod === 'upload' && !targetPos.fileObj) { alert('Please upload a file.'); return; }

          if (rowId === 'master') {
            state.positions.forEach(p => p.isSaved = true);
          } else {
            state.positions[Number(rowId)].isSaved = true;
          }
          renderArtworkStep();
         // --- MOBILE ONLY SCROLL RESET (ANDROID & iOS) ---
          if (window.innerWidth <= 768) {
            setTimeout(() => {
              // Target the wrapper instead of the dialog!
              const wrapper = document.querySelector('.pc-modal-wrapper');
              if (wrapper) wrapper.scrollTop = 0;
            }, 50);
          }
        });
      });

      artworkContainer.querySelectorAll('[data-edit-row]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const rowId = e.target.getAttribute('data-edit-row');
          if (rowId === 'master') {
            state.positions.forEach(p => p.isSaved = false);
          } else {
            state.positions[Number(rowId)].isSaved = false;
          }
          renderArtworkStep();
         // --- MOBILE ONLY SCROLL RESET (ANDROID & iOS) ---
          if (window.innerWidth <= 768) {
            setTimeout(() => {
              // Target the wrapper instead of the dialog!
              const wrapper = document.querySelector('.pc-modal-wrapper');
              if (wrapper) wrapper.scrollTop = 0;
            }, 50);
          }
        });
      });
    }

    // --- STEP 3: CONFIRM LOGIC ---
    function renderSummaryStep() {
      if (!summaryContainer) return;
      let html = '';
      
      const productName = document.querySelector('.product__title h1')?.innerText || 'Product';

      state.positions.forEach((pos, index) => {
        let artworkDisplay = pos.logoName;
        if (pos.artworkMethod === 'upload' && pos.fileName) {
          artworkDisplay = `<span class="pc-s-link">${pos.fileName}</span>`;
        } else if (pos.artworkMethod === 'email') {
          artworkDisplay += ' (Will Email)';
        } else if (pos.artworkMethod === 'file') {
          artworkDisplay += ' (On File)';
        }

        html += `
          <div class="pc-summary-card">
            <button type="button" class="pc-summary-remove" data-remove-index="${index}">
              <svg viewBox="0 0 27.43881 27.43881"><path fill="#4cbbb8" d="M13.71941,26.53691c7.079,0,12.817-5.73798,12.817-12.81702S20.79841.9019,13.71941.9019.9024,6.64091.9024,13.71989s5.738,12.81702,12.817,12.81702"/><path fill="#fff" d="M10.5923,9.96727v8.13-8.13ZM14.3453,16.84624h1.251v-5.62897h-1.251v5.62897ZM11.8433,16.84624h1.251v-5.62897h-1.251v5.62897ZM16.8463,9.96727h-6.254v8.13h6.254v-8.13ZM10.5923,19.34825c-.344,0-.638-.12201-.883-.367-.245-.245-.368-.53998-.368-.88397v-8.13h-.625v-1.25104h3.127v-.62598h3.752v.62598h3.127v1.25104h-.625v8.13c0,.34399-.12199.63898-.367.88397s-.54.367-.884.367h-6.254Z"/></svg>
              </button>
            <div class="pc-summary-img">${pos.imgSrc ? `<img src="${pos.imgSrc}">` : ''}</div>
            <div class="pc-summary-details">
              <h4 class="pc-summary-title">${productName}</h4>
              <div class="pc-summary-grid">
                <div class="pc-summary-col">
                  <div class="pc-s-row">Decoration: <strong>${pos.type}</strong></div>
                  <div class="pc-s-row">Logo Position: <strong>${pos.label}</strong></div>
                  <div class="pc-s-row">Logo Name: <strong>${pos.logoName}</strong></div>
                </div>
                <div class="pc-summary-col">
                  <div class="pc-s-row" style="color:var(--pc-teal); font-weight:600;">Uploaded Logo(s):</div>
                  <div class="pc-s-row">${artworkDisplay}</div>
                </div>
              </div>
            </div>
          </div>
        `;
      });

      summaryContainer.innerHTML = html;

      summaryContainer.querySelectorAll('[data-remove-index]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const index = Number(e.target.closest('[data-remove-index]').getAttribute('data-remove-index'));
          const posToRemove = state.positions[index];

          const cards = document.querySelectorAll('[data-position-card]');
          cards.forEach(card => {
            const checkbox = card.querySelector('.pc-pos-checkbox');
            if (checkbox && checkbox.value === posToRemove.label) {
              
              checkbox.checked = false; 
              const radios = card.querySelectorAll('input[type="radio"]');
              radios.forEach(r => r.checked = false);

              card.classList.remove('is-selected');
              card.style.borderColor = '#e5e5e5';
              
              const typeToggle = card.querySelector('.pc__pos-type-toggle');
              const checkIcon = card.querySelector('.pc__pos-check');
              if (typeToggle) typeToggle.style.display = 'none';
              if (checkIcon) checkIcon.style.display = 'none';
            }
          });

          syncPositionsState(); 
          renderSummaryStep();
          
          if (state.positions.length === 0) {
            goToStep(1); 
          }
          // --- MOBILE ONLY SCROLL RESET (ANDROID & iOS) ---
          if (window.innerWidth <= 768) {
            setTimeout(() => {
              // Target the wrapper instead of the dialog!
              const wrapper = document.querySelector('.pc-modal-wrapper');
              if (wrapper) wrapper.scrollTop = 0;
            }, 50);
          }
        });
      });
    }

    // --- ADD TO CART FINAL LOGIC ---
    if (btnCheckout) {
      btnCheckout.addEventListener('click', async function(e) {
        e.preventDefault();
        
        const qtyInputs = document.querySelectorAll('[data-bulk-input], .qty-input');
        let selectedVariants = [];
        let totalGarmentQuantity = 0;
        
        qtyInputs.forEach(input => {
          if (input.getBoundingClientRect().width === 0) return;
          const qty = parseInt(input.value) || 0;
          if (qty > 0) {
            let variantId = input.getAttribute('data-variant-id');
            if (variantId) {
              selectedVariants.push({ id: variantId, quantity: qty });
              totalGarmentQuantity += qty;
            }
          }
        });

        if (selectedVariants.length === 0) {
          alert("Please select at least one size/quantity first.");
          return;
        }

        btnCheckout.innerText = "Adding to Cart...";
        btnCheckout.disabled = true;

        const sharedLogoId = Date.now().toString();
        
        // --- CRUCIAL FIX: DECLARE THE VARIABLE HERE ---
        let dynamicEndTime = "";
        const countdownElement = document.getElementById('countdown');
        if (countdownElement) {
           dynamicEndTime = countdownElement.getAttribute('end-time') || "";
        }
        // ----------------------------------------------
        
        let printSetups = 0;
        let embroiderySetups = 0;

        if (state.artworkMode === 'each') {
           state.positions.forEach(pos => {
              if (pos.artworkMethod !== 'file') {
                 if (pos.type.toLowerCase().includes('embroidery')) embroiderySetups++;
                 if (pos.type.toLowerCase().includes('print')) printSetups++;
              }
           });
        } else {
           let needsPrint = false;
           let smallEmbroidery = false;
           let largeEmbroidery = false;

           state.positions.forEach(pos => {
              if (pos.artworkMethod !== 'file') {
                 if (pos.type.toLowerCase().includes('print')) needsPrint = true;
                 if (pos.type.toLowerCase().includes('embroidery')) {
                    if (pos.label.toLowerCase().includes('large')) {
                       largeEmbroidery = true;
                    } else {
                       smallEmbroidery = true;
                    }
                 }
              }
           });

           if (needsPrint) printSetups = 1; 
           if (smallEmbroidery) embroiderySetups++; 
           if (largeEmbroidery) embroiderySetups++; 
        }

        // --- NEW: FETCH CART TOTAL TO CALCULATE GLOBAL SMALL RUN FEE ---
        const cartRes = await fetch(window.Shopify.routes.root + 'cart.js');
        const cartData = await cartRes.json();
        
        let existingGarments = 0;
        let smallRunKeysToRemove = [];
        
        cartData.items.forEach(item => {
          if (item.properties && item.properties['Logo Id']) {
            if (!item.properties['Fee Type']) {
              existingGarments += item.quantity;
            } else if (item.properties['Fee Type'] === 'Small Run Fee') {
              smallRunKeysToRemove.push(item.key);
            }
          }
        });

        let globalTotal = existingGarments + totalGarmentQuantity;
        
        // If global total is 7 or less, and we don't already have one in the cart, add it.
        let smallRunFeeVariantId = null;
        if (globalTotal <= 7 && smallRunKeysToRemove.length === 0) {
           smallRunFeeVariantId = '57018733166857';
        }

       try {
          // If global total exceeds 7, completely wipe any existing Small Run Fees from the cart
          if (globalTotal > 7 && smallRunKeysToRemove.length > 0) {
             let updates = {};
             smallRunKeysToRemove.forEach(key => updates[key] = 0);
             await fetch(window.Shopify.routes.root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
          }

          // 1. ADD ALL GARMENTS FIRST
          for (const item of selectedVariants) {
            let formData = new FormData();
            formData.append('id', item.id);
            formData.append('quantity', item.quantity);
            formData.append('properties[Logo Id]', sharedLogoId);

            // --- NEW: PASS THE TIME TO THE CART ---
            if (dynamicEndTime) {
               formData.append('properties[_End Time]', dynamicEndTime); 
               // Note: The underscore '_' hides it from showing up visually on the cart/packing slip!
            }
            
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: formData });
            if (!response.ok) throw new Error('Error adding garment');
          }

          // 2. ADD CUSTOMISATION FEES ONCE PER POSITION (Using Total Quantity!)
          for (const pos of state.positions) {
            if (!pos.variantId) continue; 

            let feeFormData = new FormData();
            feeFormData.append('id', pos.variantId);
            feeFormData.append('quantity', totalGarmentQuantity); // Correctly applies the total bulk amount
            feeFormData.append('properties[Fee Type]', 'Customisation');
            feeFormData.append('properties[Position]', pos.label);
            feeFormData.append('properties[Application Method]', pos.type);
            feeFormData.append('properties[Artwork Method]', pos.artworkMethod);
            feeFormData.append('properties[Logo Name]', pos.logoName);
            feeFormData.append('properties[_Linked_Variant]', sharedLogoId);
            feeFormData.append('properties[Logo Id]', sharedLogoId);

            if (pos.artworkMethod === 'upload' && pos.fileObj) {
              feeFormData.append('properties[Logo file]', pos.fileObj);
            }

            const feeResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: feeFormData });
            if (!feeResponse.ok) throw new Error('Error adding position fee');
          }

          // 3. ADD PRINT SETUP FEES
          if (printSetups > 0) {
             let setupFormData = new FormData();
             setupFormData.append('id', '57018733068553');
             setupFormData.append('quantity', printSetups);
             setupFormData.append('properties[Fee Type]', 'Setup Fee');
             setupFormData.append('properties[Logo Id]', sharedLogoId);
             setupFormData.append('properties[Method]', 'Print');
             await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: setupFormData });
          }

          // 4. ADD EMBROIDERY SETUP FEES
          if (embroiderySetups > 0) {
             let setupFormData = new FormData();
             setupFormData.append('id', '57018733101321');
             setupFormData.append('quantity', embroiderySetups);
             setupFormData.append('properties[Fee Type]', 'Setup Fee');
             setupFormData.append('properties[Logo Id]', sharedLogoId);
             setupFormData.append('properties[Method]', 'Embroidery');
             await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: setupFormData });
          }

          // 5. ADD SMALL RUN FEE
          if (smallRunFeeVariantId) {
             let smallRunFormData = new FormData();
             smallRunFormData.append('id', smallRunFeeVariantId);
             smallRunFormData.append('quantity', 1);
             smallRunFormData.append('properties[Fee Type]', 'Small Run Fee');
             smallRunFormData.append('properties[Logo Id]', sharedLogoId);
             await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: smallRunFormData });
          }

          window.location.href = '/cart'; 

        } catch (error) {
          console.error(error);
          alert("Issue adding to cart: " + error.message);
          btnCheckout.innerText = "Checkout";
          btnCheckout.disabled = false;
        }
      }); 
    }

  } // <-- THIS WAS THE MISSING BRACKET THAT BROKE EVERYTHING!

  // THE ULTIMATE SAFE BINDING
  document.addEventListener('DOMContentLoaded', () => {
    initCustomiser(document); 
  });
})();


// ==========================================
// 3. INTERMEDIATE CONFIRMATION POPUP LOGIC
// ==========================================
document.addEventListener('DOMContentLoaded', function() {
  const mainAddToCartBtn = document.getElementById('bm-checkout-btn'); 
  const confModal = document.getElementById('bm-conf-modal');
  
  if (!mainAddToCartBtn || !confModal) return;

  // 1. INTERCEPT THE CLICK
  mainAddToCartBtn.addEventListener('click', function(e) {
    e.preventDefault(); 
    e.stopPropagation(); 

    const qtyInputs = document.querySelectorAll('.qty-input, [data-bulk-input]');
    let totalItems = 0;
    
    qtyInputs.forEach(input => {
      if(input.offsetParent !== null && window.getComputedStyle(input).display !== 'none') { 
        totalItems += parseInt(input.value) || 0;
      }
    });

    if (totalItems > 0) {
      populateConfirmationBox(qtyInputs, totalItems);
      // LOCK SCROLLING FOR CONFIRMATION POPUP
      document.body.classList.add('bm-modal-open'); 
      confModal.classList.remove('bm-conf-hidden'); 
    } else {
       alert("Please select at least one item before continuing.");
    }
  });

  // 2. POPULATE DYNAMIC DATA
  function populateConfirmationBox(qtyInputs, totalItems) {
    const tbody = document.getElementById('bm-conf-table-body');
    tbody.innerHTML = ''; 
    
    let groupedItems = {};

    qtyInputs.forEach(input => {
      if (input.offsetParent === null || window.getComputedStyle(input).display === 'none') return; 
      
      const qty = parseInt(input.value) || 0;
      if (qty > 0) {
        const row = input.closest('.bm-size-row, tr'); 
        
        let rawVariantName = input.getAttribute('data-variant-name') || 'One Size';
        let sizeText = rawVariantName; 
        
        let colorText = document.getElementById('bm-csb-name-display')?.innerText || row?.getAttribute('data-color') || '';

        let uniqueKey = sizeText + '-' + colorText;

        if (groupedItems[uniqueKey]) {
          groupedItems[uniqueKey].qty += qty;
        } else {
          groupedItems[uniqueKey] = { size: sizeText, color: colorText, qty: qty };
        }
      }
    });

    Object.values(groupedItems).forEach(item => {
      tbody.innerHTML += `
        <tr>
          <td>${item.size}</td>
          <td>${item.color}</td>
          <td>${item.qty}</td>
        </tr>
      `;
    });

    const finalTotalEl = document.getElementById('bm-sb-final');
    let totalPriceText = finalTotalEl ? finalTotalEl.innerText.replace(/[^0-9.]/g, '') : '0.00';
    let totalPrice = parseFloat(totalPriceText) || 0;
    
    let effectiveUnitPrice = totalItems > 0 ? (totalPrice / totalItems) : 0;

    const vatLabelEl = document.querySelector('.vat-label-text');
    let vatText = vatLabelEl ? vatLabelEl.innerText : '(exc. VAT)';

    document.getElementById('bm-conf-total-items').innerText = `${totalItems} Items`;
    document.getElementById('bm-conf-unit-price-val').innerText = `£${effectiveUnitPrice.toFixed(2)}`;
    document.getElementById('bm-conf-total-val').innerText = `£${totalPrice.toFixed(2)}`;
    document.getElementById('bm-conf-vat-label').innerText = vatText;
  }

  // 3. ADD LOGO NOW
  document.getElementById('btn-conf-add-logo').addEventListener('click', function() {
    confModal.classList.add('bm-conf-hidden'); 
    if (typeof window.pcOpenModal === 'function') {
      window.pcOpenModal(); 
    }
  });

  // 4. PROCEED TO CHECKOUT
  // 4. PROCEED TO CHECKOUT (Buying Blank Garments)
  document.getElementById('btn-conf-checkout').addEventListener('click', async function() {
    this.innerText = "Adding to basket...";
    this.disabled = true;

    const qtyInputs = document.querySelectorAll('.qty-input, [data-bulk-input]');
    let itemsToAdd = [];
    
    // GENERATE A UNIQUE ID SO THE CART FORCES THE NEW MATRIX LAYOUT
    const sharedLogoId = Date.now().toString(); 

    let dynamicEndTime = "";
        const countdownElement = document.getElementById('countdown');
        if (countdownElement) {
           dynamicEndTime = countdownElement.getAttribute('end-time') || "";
        }

    qtyInputs.forEach(input => {
      if (input.offsetParent === null || window.getComputedStyle(input).display === 'none') return;
      const qty = parseInt(input.value) || 0;
      if (qty > 0) {
        let variantId = input.getAttribute('data-variant-id');
        if (variantId) {
          // Create the properties object
          let itemProperties = {
            'Logo Id': sharedLogoId,
            'Decoration': 'None (Blank Garment)'
          };

          // Attach the secret time if it exists!
          if (dynamicEndTime) {
             itemProperties['_End Time'] = dynamicEndTime;
          }

          itemsToAdd.push({ 
            id: variantId, 
            quantity: qty,
            properties: itemProperties
          });
        }
      }
    });

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      });
      
      if (!response.ok) throw new Error('Error adding to cart');
      window.location.href = '/cart'; 
    } catch (error) {
      console.error(error);
      alert("Issue adding to cart. Please try again.");
      this.innerText = "Proceed to Checkout";
      this.disabled = false;
    }
  });

  // 5. CONTINUE SHOPPING / CLOSE
  document.querySelectorAll('[data-conf-close]').forEach(btn => {
    btn.addEventListener('click', function() {
      confModal.classList.add('bm-conf-hidden');
      // UNLOCK SCROLLING
      document.body.classList.remove('bm-modal-open'); 
    });
  });
});


// // ==========================================
// 4. MATRIX QUANTITY & TOTALS LOGIC
// ==========================================
(function() {
  // 1. Handle Plus/Minus Clicks via Event Delegation
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.bm-qty-btn');
    if (!btn || btn.disabled) return;

    // Stop duplicate clicks
    e.preventDefault();
    e.stopImmediatePropagation(); 

    const row = btn.closest('.bm-size-row');
    const input = row.querySelector('[data-bulk-input]');
    if (!input || input.disabled) return;

    let val = parseInt(input.value) || 0;
    const max = parseInt(input.getAttribute('max')) || 9999;
    const min = parseInt(input.getAttribute('min')) || 0;

    if (btn.hasAttribute('data-bulk-plus') && val < max) {
      input.value = val + 1;
    } else if (btn.hasAttribute('data-bulk-minus') && val > min) {
      input.value = val - 1;
    }

    // Trigger calculations
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }, true);

  // 2. Handle Calculations & Tiers on Input Change
  document.addEventListener('input', function(e) {
    if (!e.target.matches('[data-bulk-input]')) return;

    const matrix = document.getElementById('bm-bulk-matrix');
    if (!matrix) return;
    
    // Check current VAT toggle state by looking at the first unit price
    let isExVat = false;
    const firstPriceEl = matrix.querySelector('.bm-variant-price.price__container');
    if (firstPriceEl) {
      const displaySpan = firstPriceEl.querySelector('.price-item--regular');
      if (displaySpan && displaySpan.innerText === firstPriceEl.getAttribute('data-price')) {
        isExVat = true;
      }
    }
    
    const rows = matrix.querySelectorAll('[data-variant-card]');
    let globalTotalItems = 0;
    let globalSubtotal = 0;

    // Calculate Row Totals
    rows.forEach(row => {
      const input = row.querySelector('[data-bulk-input]');
      if (!input) return;

      const qty = parseInt(input.value) || 0;
      const unitPriceInc = parseFloat(input.getAttribute('data-unit-price')) || 0;
      const rowTotalContainer = row.querySelector('.bm-row-total');
      const rowTotalVal = row.querySelector('.bm-row-total-val');

      if (qty > 0) {
        // Calculate both Inc and Ex VAT row totals
        const lineTotalInc = qty * unitPriceInc;
        const lineTotalEx = lineTotalInc / 1.2;
        
        globalSubtotal += lineTotalInc;
        globalTotalItems += qty;

        const fmtInc = '£' + (lineTotalInc / 100).toFixed(2);
        const fmtEx = '£' + (lineTotalEx / 100).toFixed(2);

        if (rowTotalContainer) {
          rowTotalContainer.setAttribute('data-price-vat', fmtInc);
          rowTotalContainer.setAttribute('data-price', fmtEx);
          rowTotalContainer.style.opacity = '1';
        }
        if (rowTotalVal) {
          // Display the correct string based on the toggle's current state
          rowTotalVal.innerText = isExVat ? fmtEx : fmtInc;
        }
        row.classList.add('has-qty');
      } else {
        if (rowTotalContainer) rowTotalContainer.style.opacity = '0';
        row.classList.remove('has-qty');
      }
    });

  // 3. APPLY TIER DISCOUNTS (5%, 10%, 15%)
    let discountMultiplier = 1;
    let discountText = '';
    let progressPercent = 0;
    const discountFill = document.getElementById('bm-discount-fill');
    const discountHint = document.getElementById('bm-discount-hint');
    const badgeEl = document.getElementById('bm-sb-badge');

   if (globalTotalItems >= 50) {
      discountMultiplier = 0.85; // Changes math to 15% off
      discountText = '15% off';  // Changes badge text
      progressPercent = 100;
      if(discountHint) discountHint.innerText = "Maximum discount reached!";
    } else if (globalTotalItems >= 25) {
      discountMultiplier = 0.90;
      discountText = '10% off';
      progressPercent = 55;
      if(discountHint) discountHint.innerText = "Order " + (50 - globalTotalItems) + " more for 15% off";
    } else if (globalTotalItems >= 10) {
      discountMultiplier = 0.95;
      discountText = '5% off';
      progressPercent = 20;
      if(discountHint) discountHint.innerText = "Order " + (25 - globalTotalItems) + " more for 10% off";
    } else {
      progressPercent = (globalTotalItems / 10) * 20;
      if(discountHint) discountHint.innerText = "Order " + (10 - globalTotalItems) + " more for next price reduction";
    }
    if (discountFill) discountFill.style.width = Math.min(progressPercent, 100) + '%';

    // 4. Update the Main Summary Bar Totals
    const summaryCount = document.getElementById('bm-sb-count');
    const summaryFinalContainer = document.getElementById('bm-sb-final-container');
    const summaryFinal = document.getElementById('bm-sb-final');
    const originalPriceContainer = document.getElementById('bm-sb-original-container');
    const originalPriceEl = document.getElementById('bm-sb-original');
    const checkoutBtn = document.getElementById('bm-checkout-btn');

    if (summaryCount) summaryCount.innerText = globalTotalItems + (globalTotalItems === 1 ? ' Item Selected' : ' Items Selected');
    
    // Calculate both Inc and Ex VAT final prices
    const finalPriceInc = globalSubtotal * discountMultiplier;
    const finalPriceEx = (globalSubtotal / 1.2) * discountMultiplier;
    
    const fmtFinalInc = '£' + (finalPriceInc / 100).toFixed(2);
    const fmtFinalEx = '£' + (finalPriceEx / 100).toFixed(2);

    if (summaryFinalContainer) {
      summaryFinalContainer.setAttribute('data-price-vat', fmtFinalInc);
      summaryFinalContainer.setAttribute('data-price', fmtFinalEx);
    }
    if (summaryFinal) {
      summaryFinal.innerText = isExVat ? fmtFinalEx : fmtFinalInc;
    }

    // Show Original Price strike-through if discounted
    if (globalSubtotal > finalPriceInc) {
      const fmtSubInc = '£' + (globalSubtotal / 100).toFixed(2);
      const fmtSubEx = '£' + ((globalSubtotal / 1.2) / 100).toFixed(2);
      
      if (originalPriceContainer) {
        originalPriceContainer.setAttribute('data-price-vat', fmtSubInc);
        originalPriceContainer.setAttribute('data-price', fmtSubEx);
      }
      if (originalPriceEl) {
        originalPriceEl.style.display = 'inline-block';
        originalPriceEl.innerText = isExVat ? fmtSubEx : fmtSubInc;
      }
      if (badgeEl) {
        badgeEl.style.display = 'inline-block';
        badgeEl.innerText = discountText;
      }
    } else {
      if (originalPriceEl) originalPriceEl.style.display = 'none';
      if (badgeEl) badgeEl.style.display = 'none';
    }

    // Toggle the Add to Cart/Checkout Button
    if (globalTotalItems > 0) {
      checkoutBtn.classList.remove('is-disabled');
      checkoutBtn.classList.add('is-active');
      checkoutBtn.removeAttribute('disabled');
    } else {
      checkoutBtn.classList.add('is-disabled');
      checkoutBtn.classList.remove('is-active');
      checkoutBtn.setAttribute('disabled', 'disabled');
    }
  });
})();